import { NodeSizeParams } from '../'
import { branch } from '../constants'

module.exports = () ->
  { className } = NodeSizeParams
  configNode = new Weaver.Node(className)
  configNode.set('name', className)
  await configNode.save({ branch, commitMessage: "Add Node Size Params Migration." })
  nodeSizeParams = new NodeSizeParams()
  await nodeSizeParams.reset()
